import {
  PLAID_LINK_INTENTS,
  PLAID_LINK_ORIGINS,
} from 'features/plaid/constants/PlaidLinkOrigins';
import { PlaidMarketingConsentEntryPoint } from 'features/plaid/hooks/useHasPlaidMarketingConsent';
import usePlaidLauncher from 'features/plaid/hooks/usePlaidLauncher';
import { PlaidOpenResult } from 'shared/hooks/usePlaidV2/types';

type UsePlaidLinkLauncherOptions = {
  onResult: (result: PlaidOpenResult) => void;
};

/**
 * Drives a Plaid V2 `Link` flow for one of the origins in `PLAID_LINK_ORIGINS`,
 * so the entry point, product, and analytics `source_name` always travel
 * together.
 *
 * @param entryPoint The launching surface — the same value the surface passes
 * to `useHasPlaidMarketingConsent`.
 * @param options `onResult` receives every `openPlaid()` outcome.
 * @returns The same `startLaunch` / `cancelLaunch` / `error` as
 * {@link usePlaidLauncher}.
 */
const usePlaidLinkLauncher = (
  entryPoint: PlaidMarketingConsentEntryPoint,
  { onResult }: UsePlaidLinkLauncherOptions,
) =>
  usePlaidLauncher(PLAID_LINK_INTENTS[entryPoint], {
    sourceName: PLAID_LINK_ORIGINS[entryPoint].sourceName,
    onResult,
  });

export default usePlaidLinkLauncher;
